import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { getStatsCategories, StatsCategory } from 'Douleutaras/redux/data/stats/categories';
import { getStatsIntro, StatsIntro } from 'Douleutaras/redux/data/stats/Intro';
import { getStatsOverview, StatsOverview } from 'Douleutaras/redux/data/stats/overview';
import { getStatsPerformance, StatsPerformance } from 'Douleutaras/redux/data/stats/performance';
import { getHallOfFame, HallOfFame } from 'Douleutaras/redux/data/stats/tierRanking';
import { Competitors, getCompetitors } from 'Douleutaras/redux/data/stats/competitors';
import { getProsScore, ProsScore } from 'Douleutaras/redux/data/stats/prosScore';

export interface StatsSliceModel {
  selectedDate: {
    from: string;
    to: string;
  };
  selectedCat: StatsCategory;
  categoriesLoading: boolean;
  introLoading: boolean;
  overviewLoading: boolean;
  performanceLoading: boolean;
  hallOfFameLoading: boolean;
  competitorsLoading: boolean;
  prosScoreLoading: boolean;
  categories: Array<StatsCategory>;
  intro: StatsIntro;
  overview: StatsOverview;
  performance: StatsPerformance;
  hallOfFame: Array<HallOfFame>;
  competitors: Competitors;
  prosScore: ProsScore;
}

export const statsSlice = createSlice({
  name: 'stats',
  initialState: {
    selectedDate: {},
    selectedCat: {},
    categoriesLoading: false,
    introLoading: false,
    overviewLoading: false,
    performanceLoading: false,
    hallOfFameLoading: false,
    prosScoreLoading: false,
    categories: [],
    intro: {},
    overview: {},
    performance: {},
    hallOfFame: [],
    prosScore: {
      proScore: 0
    },
    competitors: {}
  } as StatsSliceModel,
  reducers: {
    setSelectedDate(state, { payload: { from, to } }): void {
      state.selectedDate = {
        from: moment(from)
          .format('YYYYMMDD'),
        to: moment(to)
          .format('YYYYMMDD')
      };
    },
    setSelectedCat(state, { payload }): void {
      state.selectedCat = payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(getStatsCategories.pending, state => {
      state.categoriesLoading = true;
    });
    builder.addCase(getStatsCategories.fulfilled, (state, action) => {
      state.categoriesLoading = false;
      state.categories = action.payload;
    });
    builder.addCase(getStatsIntro.pending, state => {
      state.introLoading = true;
    });
    builder.addCase(getStatsIntro.fulfilled, (state, action) => {
      state.introLoading = false;
      state.intro = action.payload;
    });
    builder.addCase(getStatsOverview.pending, state => {
      state.overviewLoading = true;
    });
    builder.addCase(getStatsOverview.fulfilled, (state, action) => {
      state.overviewLoading = false;
      state.overview = action.payload;
    });
    builder.addCase(getStatsPerformance.pending, state => {
      state.performanceLoading = true;
    });
    builder.addCase(getStatsPerformance.fulfilled, (state, action) => {
      state.performanceLoading = false;
      state.performance = action.payload;
    });
    builder.addCase(getHallOfFame.pending, state => {
      state.hallOfFameLoading = true;
    });
    builder.addCase(getHallOfFame.fulfilled, (state, action) => {
      state.hallOfFameLoading = false;
      state.hallOfFame = action.payload;
    });
    builder.addCase(getCompetitors.pending, state => {
      state.competitorsLoading = true;
    });
    builder.addCase(getCompetitors.fulfilled, (state, action) => {
      state.competitorsLoading = false;
      state.competitors = action.payload;
    });
    builder.addCase(getProsScore.pending, state => {
      state.prosScoreLoading = true;
    });
    builder.addCase(getProsScore.fulfilled, (state, action) => {
      state.prosScoreLoading = false;
      state.prosScore = action.payload.attributes;
    });
    builder.addCase(getProsScore.rejected, (state, action) => {
      state.prosScoreLoading = false;
    });
  }
});

export const { setSelectedDate, setSelectedCat } = statsSlice.actions;
